import * as api from '../api';
import { getIsFetching } from '../reducers/otherPestsRef';

export const FETCH_OTHER_PESTS = 'intervention.FETCH_OTHER_PESTS';
export const FETCH_OTHER_PESTS_SUCCESS =
  'intervention.FETCH_OTHER_PESTS_SUCCESS';

const requestOtherPestsRef = () => ({
  type: FETCH_OTHER_PESTS,
});

const receiveOtherPestsRef = refs => ({
  type: FETCH_OTHER_PESTS_SUCCESS,
  refs,
});

export const fetchOtherPestsRef = () => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestOtherPestsRef());

  // Request interventions fetching then planning
  return api
    .getOtherPestsSpeciesRef()
    .then(response => dispatch(receiveOtherPestsRef(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/otherPestsRef.js